import React, { useState } from 'react'
import { Space } from 'antd'
import { DeleteFilled, PlusOutlined } from '@ant-design/icons'
import '@/plugins/desc.less'
import {
    Radio,
    Select,
    ConfigTitle,
    Slider,
    BaseButton,
} from '@/components'
import { InputNumber3x, HotArea, Slider3x, InputWithImg } from '@/HOC'
import _ from 'lodash'
export default function Desc({
    currentPlugin,
    changeCurrentPluginRect,
    updateCurrentPluginProps,
    deleteInsertPlugin,
}) {
    const { props, rectOptions, extension } = currentPlugin
    const { direction, scrollList, between, scrollItemWidth, scrollItemHeight, scrollWrapWidth, speed } = props
    const [currentIndex, setCurrentIndex] = useState(0)
    return (
        <div
            className="desc-wrap"
        >
            <ConfigTitle
                style={{
                    padding: '20px 0 5px 20px'
                }}
                title="无限滚屏"
                detail="可设置向左或向右匀速自动滚动"
            />
            <div className="desc-board">
                <Space
                    direction="vertical"
                    size={10}
                >
                    <ConfigTitle
                        title="滚屏素材设置"
                        detail="每张图片可单独编辑热区"
                        style={{
                            height: 37,
                        }}
                        titleSize={14}
                        detailSize={12}
                    />
                    <Select
                        chooseList={scrollList.map((v, i) => `第${i + 1}组`)}
                        onClick={(idx) => {
                            setCurrentIndex(idx)
                        }}
                        currentIndex={currentIndex}
                        onDrop={(newIndexGrp) => {
                            const newList = []
                            newIndexGrp.forEach((i) => {
                                newList.push(scrollList[i])
                            })
                            updateCurrentPluginProps({
                                scrollList: newList,
                            })
                        }}
                    />
                    <InputWithImg
                        labelContent="图片链接"
                        defaultValue={scrollList[currentIndex].imageUrl}
                        onChange={(e) => {
                            const list = [...scrollList]
                            list[currentIndex].imageUrl = e
                            updateCurrentPluginProps({
                                scrollList: list,
                            })
                        }}
                    />
                    <HotArea
                        editContentSize={{
                            width: scrollItemWidth,
                            height: scrollItemHeight,
                        }}
                        editContent={scrollList[currentIndex].imageUrl}
                        defaultValue={scrollList[currentIndex].hotArea}
                        contentFit="fill"
                        onSave={(data) => {
                            const list = [...props.scrollList]
                            list[currentIndex].hotArea = data
                            updateCurrentPluginProps({
                                scrollList: list,
                            })
                        }}
                        showCopyBtn={currentIndex !== 0}
                        onCopy={() => {
                            const list = [...props.scrollList]
                            list[currentIndex].hotArea = _.cloneDeep(list[0].hotArea, {})
                            updateCurrentPluginProps({
                                scrollList: list,
                            })
                        }}
                    />
                    <Space>
                        <BaseButton
                            style={{
                                width: 155
                            }}
                            type="normal"
                            icon={<DeleteFilled />}
                            content="删除本组"
                            onClick={() => {
                                const list = [...scrollList]
                                list.splice(currentIndex, 1)
                                if (list.length === 0) {
                                    deleteInsertPlugin(currentPlugin.insertId)
                                } else {
                                    setCurrentIndex(0)
                                    updateCurrentPluginProps({
                                        scrollList: list,
                                    })
                                }
                            }}
                        />
                        <BaseButton
                            style={{
                                width: 155
                            }}
                            type="normal"
                            icon={<PlusOutlined />}
                            content="添加帧数"
                            onClick={() => {
                                const list = [...scrollList]
                                list.push(Object.assign({}, extension.struct))
                                updateCurrentPluginProps({
                                    scrollList: list
                                })
                            }}
                        />
                    </Space>
                </Space>
            </div>
            <div className="desc-board">
                <Space
                    direction="vertical"
                    size={10}
                >
                    <ConfigTitle
                        title="滚屏动画设置"
                        style={{
                            height: 21,
                        }}
                        titleSize={14}
                        detailSize={0}
                    />
                    <Space size={10}>
                        <InputNumber3x
                            labelContent="宽"
                            size="middle"
                            style={{
                                color: '#696969',
                            }}
                            onChange={(val) => {
                                updateCurrentPluginProps({
                                    scrollItemWidth: val
                                })
                            }}
                            defaultValue={scrollItemWidth}
                        />
                        <InputNumber3x
                            labelContent="高"
                            size="middle"
                            style={{
                                color: '#696969',
                            }}
                            onChange={(val) => {
                                updateCurrentPluginProps({
                                    scrollItemHeight: val
                                })
                            }}
                            defaultValue={scrollItemHeight}
                        />
                    </Space>
                    <Space size={10}>
                        <InputNumber3x
                            labelContent="上边距"
                            size="middle"
                            style={{
                                color: '#696969',
                            }}
                            onChange={(val) => {
                                changeCurrentPluginRect({
                                    top: val
                                })
                            }}
                            defaultValue={rectOptions.top}
                        />
                        <InputNumber3x
                            labelContent="左边距"
                            size="middle"
                            style={{
                                color: '#696969',
                            }}
                            onChange={(val) => {
                                changeCurrentPluginRect({
                                    left: val
                                })
                            }}
                            defaultValue={rectOptions.left}
                        />
                    </Space>
                    <InputNumber3x
                        labelContent="间距"
                        size="middle"
                        style={{
                            color: '#696969',
                        }}
                        onChange={(val) => {
                            updateCurrentPluginProps({
                                between: val
                            })
                        }}
                        defaultValue={between}
                    />
                    <Radio
                        title="滚动方向"
                        defaultValue={props.direction}
                        radioList={['向左', '向右']}
                        onChange={(v) => {
                            updateCurrentPluginProps({
                                direction: v,
                            })
                        }}
                    />
                    <Slider3x
                        title="滑动宽度"
                        min={extension.scrollWidthDuration[0]}
                        max={extension.scrollWidthDuration[1]}
                        defaultValue={scrollWrapWidth}
                        suffix="px"
                        onChange={(v) => {
                            updateCurrentPluginProps({
                                scrollWrapWidth: v,
                            })
                        }}
                    />
                    <Slider
                        title="自动滚动速度"
                        suffix=""
                        min={extension.speedDuration[0]}
                        max={extension.speedDuration[1]}
                        defaultValue={speed}
                        onChange={(v) => {
                            updateCurrentPluginProps({
                                speed: v,
                            })
                        }}
                    />
                </Space>
            </div>
        </div>
    )
}